<script>
import helper from "./../mixins/helper";
import axios from "axios";

export default {
    render(){},
    mixins: [helper],
    components: {
        
    },
    props: {
        id: {
            required: true
        }
    },
    data() {
        return {
        }
    },
    beforeMount() {
    },
    mounted() {
        this.getAndSaveCookies();
    },
    methods: {
        getAndSaveCookies() {
            this.getCookie('viewed_products', this.saveCookies);
        },
        saveCookies(response) {
            let items = [];
            if (this.isset(response.data.data)) {
                items = JSON.parse(response.data.data);
                items = items.filter(item => item !== this.id)
                items = items.slice(-9);
            }
            items.unshift(this.id); // TODO set order for products viewed in cart vue template by order in cookies
            // console.log('------------ item viewed ---------');
            // console.log(items);
            this.setCookie('viewed_products', JSON.stringify(items), 14);
        }
    }
}
</script>